var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"end"},[_c('el-footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-content"},[_c('p',[_vm._v("© 2025 某某大学. 版权所有.")]),_c('p',[_vm._v("地址: 某某市某某路123号 | 电话: 123-456-7890")]),_c('p',[_vm._v("邮箱: info@university.edu")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }